import React from 'react';
import classnames from 'classnames/bind';
import { numberWithCommas } from 'app/libs/number';
import styles from './LimitShortageAmount.module.scss';

const cx = classnames.bind(styles);

const LimitShortageAmount = ({ carPrice = 0, carMaximumLimit = 0, limitShortageAmount = 0 }) => (
	<div className={cx('root')}>
		<dl>
			<div className={cx('item')}>
				<dt>
					대출필요금액<span className={cx('suffix')}>(차량가격)</span>
				</dt>
				<dd>{numberWithCommas(carPrice)}원</dd>
			</div>
			<div className={cx('item')}>
				<dt>가능한도</dt>
				<dd>- {numberWithCommas(carMaximumLimit)}원</dd>
			</div>
			<div className={cx('item')}>
				<dt>한도 부족 금액</dt>
				<dd>*{numberWithCommas(limitShortageAmount)}원</dd>
			</div>
		</dl>
	</div>
);

export default LimitShortageAmount;
